import { useMutation, useQuery } from '@tanstack/react-query';
import {
  stripeCreateBillingPortalSession,
  stripeCreateSubscription,
  stripeGetPrices,
  StripePrice,
} from '../actions/stripe';
import { getQueryClient } from '../lib/get-query-client';
import { USER_QUERY_KEY, userQueryOptions } from '../providers/UserProvider';

// The subscription rides along with the user in the shared `/api/me` query (see UserProvider), so this
// reads from that single request rather than firing its own server-action POST on every page load.
export const useStripeSubscription = () => {
  return useQuery({
    ...userQueryOptions,
    select: (data) => data?.subscription ?? null,
  });
};

export const useStripeCreateSubscription = () => {
  return useMutation({
    mutationFn: async ({ successURL, price }: { successURL: string; price: StripePrice }) =>
      await stripeCreateSubscription(successURL, price),
    onSuccess: () => {
      getQueryClient().invalidateQueries({ queryKey: USER_QUERY_KEY });
    },
  });
};

export const useStripeCreateBillingPortalSession = () => {
  return useMutation({
    mutationFn: async () => await stripeCreateBillingPortalSession(),
    onSuccess: () => {
      getQueryClient().invalidateQueries({ queryKey: USER_QUERY_KEY });
    },
  });
};

export const useStripeGetPrices = (lookupKeys: string[]) => {
  return useQuery({
    queryKey: ['stripePrices', lookupKeys],
    queryFn: () => stripeGetPrices(lookupKeys),
    enabled: lookupKeys.length > 0,
  });
};
